import { Component, OnInit, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TenderService } from '../../../services/tender.service';
import { LoadingState } from '../../loading/loading.component';
import { AddDataFactorModalComponent } from '../add-data-factor-modal/add-data-factor-modal.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-resource-hydrological-tab',
  templateUrl: './resource-hydrological-tab.component.html',
  styleUrls: ['./resource-hydrological-tab.component.scss']
})
export class ResourceHydrologicalTabComponent implements OnInit {

  @Input() tenderId: number;
  loading: LoadingState = LoadingState.NotReady;
  tenderHydrologicalList: any = [];
  constructor(
    public dialog: MatDialog,
    private tenderService: TenderService
  ) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    var forkArray = [];
    var params = '';
    params = '?tender=' + this.tenderId
    forkArray.push(this.tenderService.getTenderResourceHydrologicalList(params))
    forkJoin(forkArray).subscribe(
      (res: any[]) => {
       // console.log(res)
        for (var i = 0; i < res.length; i++) {
          if (i == 0) {
            this.tenderHydrologicalList = res[i]['result'];
          }
        }
        this.loading = LoadingState.Ready
      },
      error => {
        console.log(error)
        this.loading = LoadingState.Ready
      }
    )
  }



  openHydrologicalModal() {
    let dialogRef = this.dialog.open(AddDataFactorModalComponent, {
      width: '525px',
      data: { tenderId: this.tenderId }
    });
    dialogRef.afterClosed().subscribe(result => {
     // console.log(result)
      if (result['data'] != undefined) {
        this.tenderHydrologicalList.push(result['data'])
      }
    })
  }

  editHydrological(i) {
    let hydrologicalDetailsData = Object.assign({}, this.tenderHydrologicalList[i]);
    let dialogRef = this.dialog.open(AddDataFactorModalComponent, {
      width: '525px',
      data: { tenderId: this.tenderId, hydrologicalDetails: hydrologicalDetailsData }
    });
    dialogRef.afterClosed().subscribe(result => {
     // console.log(result)
      if (result['data'] != undefined) {
        this.tenderHydrologicalList[i] = result['data']
      }
    })
  }

}
